// components/MalaysiaMap.jsx
import ObjectMarker from "./ObjectMarker";

const LOCATIONS = [
  {
    left: "28.6%",
    top: "78%",
    title: "Xin Chuan",
    phone: "+6019-578-0801",
    email: "sales@xinchuan.site",
    address: "5375, Jalan Kenari 20, Bandar Putra Kulai, Johor, Malaysia",
  },
  /* …other spots… */
];

export default function MalaysiaMap() {
  return (
    <div className="objects">
      <img src="/img/map2.png" alt="Malaysia map" className="img-responsive" />

      {LOCATIONS.map((loc) => (
        <ObjectMarker key={loc.title} {...loc} />
      ))}
    </div>
  );
}
